// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FunnelChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import PieChartOptionsBuilder from './Izenda.PieChartOptionsBuilder';
import { exportClass } from 'share/Izenda.ServiceProvider';

@exportClass('FunnelChartOptionsBuilder')
export default class FunnelChartOptionsBuilder extends PieChartOptionsBuilder {
  constructor(...baseArgs) {
    super(...baseArgs);
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   */
  buildOptionsByType(visualType: string, userOptions, dataParser): Object {
    const basedOptions = super.buildOptionsByType(visualType, userOptions, dataParser);

    delete basedOptions.chart.type;

    return $izenda.extend(true, {}, basedOptions, {
      plotOptions: {
        funnel: {
          neckWidth: '40%',
          neckHeight: '30%',
          width: '60%',
          center: ['30%', '50%'],
          showInLegend: true
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.FunnelChartOptionsBuilder.js